import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dddd1a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-multi-check" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "txt-danger txt-required"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "c-option" }
const _hoisted_7 = { class: "select-valued" }
const _hoisted_8 = {
  key: 0,
  class: "mr5 selected-value"
}
const _hoisted_9 = { class: "mr5 selected-value" }
const _hoisted_10 = {
  key: 2,
  class: "font15"
}
const _hoisted_11 = { class: "c-select-dropdown-item" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  class: /*#__PURE__*/_normalizeClass('txt-info bold font15 cursor')
}
const _hoisted_14 = ["checked"]
const _hoisted_15 = { class: "row c-select-option-list" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["checked"]
const _hoisted_18 = {
  class: /*#__PURE__*/_normalizeClass('txt-info bold font15 cursor')
}
const _hoisted_19 = ["checked"]
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = {
  key: 1,
  class: "mb0 txt-danger font14 mt3"
}

export function render(_ctx, _cache) {
  const _directive_outside = _resolveDirective("outside")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.updatedLabel,
          class: "txt-ellipsis bold"
        }, [
          _createTextVNode(_toDisplayString(_ctx.updatedLabel && _ctx.$t(_ctx.updatedLabel)) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      onClick: _cache[16] || (_cache[16] = (...args) => (_ctx.onSelect && _ctx.onSelect(...args))),
      onKeydown: [
        _cache[17] || (_cache[17] = (...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args))),
        _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
      ],
      tabindex: "0",
      class: _normalizeClass([{'active' : _ctx.isDropdown, 'outline-danger': _ctx.isError, 'select-box-disabled' : _ctx.readonly}, "row c-select"])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.selectedValue.length > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(`${_ctx.selectedValue.length} ${_ctx.$t("componentItemSelected")}`), 1))
            : (_ctx.selectedValue.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.selectedValue, (option) => {
                  return (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(option[_ctx.optionLabel]), 1))
                }), 256))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.placeholder && _ctx.$t(_ctx.placeholder) || _ctx.$t('componentSelect')) + " " + _toDisplayString(_ctx.updatedLabel && _ctx.$t(_ctx.updatedLabel)), 1))
        ]),
        (!_ctx.readonly && _ctx.clear && _ctx.value.length)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              onClick: [
                _cache[0] || (_cache[0] = (...args) => (_ctx.deleteValue && _ctx.deleteValue(...args))),
                _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              ],
              onDblclick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
              class: "fa fa-times-circle bold ic-arrow-down",
              style: {"right":"40px","color":"var(--gray-dark)"}
            }, null, 32))
          : _createCommentVNode("", true),
        _createElementVNode("i", {
          class: _normalizeClass([_ctx.isDropdown ? 'icon-element-up':'icon-element-down', {'mr0' : _ctx.readonly && _ctx.selectedValue.length}, "fa-angle-down fa bold ic-arrow-down"])
        }, null, 2)
      ]),
      (_ctx.isDropdown)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([[_ctx.isTop ? 'bottom-dropdown' : 'top-dropdown'], "c-select-dropdown c-select-dropdown-active"]),
            onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.searchable && !_ctx.isTop)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    onInput: _cache[3] || (_cache[3] = (...args) => (_ctx.onFilter && _ctx.onFilter(...args))),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.keySearch) = $event)),
                    ref: "keySearchQuery",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                    placeholder: _ctx.$t('componentSearch'),
                    type: "text",
                    class: "input mb10 c-search-input"
                  }, null, 40, _hoisted_12)), [
                    [_vModelText, _ctx.keySearch]
                  ])
                : _createCommentVNode("", true),
              (!_ctx.isTop)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                    class: "row mt10 mb10"
                  }, [
                    _createElementVNode("label", _hoisted_13, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: _ctx.isCreateSelect,
                        onChange: _cache[6] || (_cache[6] = (...args) => (_ctx.toggleCreateSelect && _ctx.toggleCreateSelect(...args))),
                        class: "input-checkbox"
                      }, null, 40, _hoisted_14),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("componentSelectMore")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionList, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    onClick: [
                      $event => (_ctx.onSelectValue(item)),
                      _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                    ],
                    key: item,
                    class: _normalizeClass([{'active' : _ctx.findActiveOption(item[_ctx.optionLabel])}, "font15"])
                  }, [
                    _createElementVNode("input", {
                      class: "input-checkbox",
                      type: "checkbox",
                      checked: _ctx.findActiveOption(item[_ctx.optionLabel])
                    }, null, 8, _hoisted_17),
                    _createElementVNode("span", null, _toDisplayString(item[_ctx.optionLabel]), 1)
                  ], 10, _hoisted_16))
                }), 128)),
                (!_ctx.optionList.length)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                      class: "no-select-data"
                    }, _toDisplayString(_ctx.$t('componentEmptyData')), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isTop)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                    class: "row mt10"
                  }, [
                    _createElementVNode("label", _hoisted_18, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: _ctx.isCreateSelect,
                        onChange: _cache[10] || (_cache[10] = (...args) => (_ctx.toggleCreateSelect && _ctx.toggleCreateSelect(...args))),
                        class: "input-checkbox"
                      }, null, 40, _hoisted_19),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("componentSelectMore")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.searchable && _ctx.isTop)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 3,
                    onInput: _cache[12] || (_cache[12] = (...args) => (_ctx.onFilter && _ctx.onFilter(...args))),
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.keySearch) = $event)),
                    ref: "keySearchQuery",
                    onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
                    placeholder: _ctx.$t('componentSearch'),
                    type: "text",
                    class: "input mb10 c-search-input"
                  }, null, 40, _hoisted_20)), [
                    [_vModelText, _ctx.keySearch]
                  ])
                : _createCommentVNode("", true)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ], 34)), [
      [_directive_outside, _ctx.outsideClick]
    ]),
    (_ctx.isError && _ctx.showError)
      ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.isError)), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}